module.exports = __webpack_public_path__ + "static/media/SB-aggroOTF-low.19fae75d.otf";